// Resources
import { fetchAppointments } from "./fetchAppointments";
import { hasAppointmentTimePassed } from "./hasAppointmentTimePassed";

export const getAvailableClinicSlots = async ({ patient, appointment }) => {
  if (hasAppointmentTimePassed(appointment.date, appointment.startTime)) {
    throw new Error("RESCHEDULE_TIME_PASSED");
  }

  return fetchAppointments(
    patient,
    appointment.type,
    null,
    appointment.clinicId
  );
};
